<template>
  <b-container class="mt-4">
    <b-row class="mb-4">
      <b-col class="d-flex justify-content-start align-items-center">
        <h4>Eligibility settings for onboarding clients</h4>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-table responsive :fields="tableFields" :busy="loading"
                 :items="clients" outlined sticky-header="800px" striped>
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template #cell(actions)="data">
              <b-button variant="outline-secondary" @click="loadEligibilityInfo(data.item)">
                Quick details
              </b-button>
              <b-button variant="outline-primary" class="ml-3"
                        v-if="$acl.check('onboarding.eligibility.configs.edit')"
                        :to="`/onboarding/clients/${data.item.id}/eligibility`">
                Edit
              </b-button>
          </template>
        </b-table>

        <b-modal id="modal-eligibility-details" title="Eligibility details" size="lg" hide-footer>
          <b-container class="p-3" v-if="detailed_client.client">
            <p><b>ID:</b> {{detailed_client.client.id}}</p>
            <p><b>Name:</b> {{detailed_client.client.display_name}}</p>
            <b-card no-body>
              <pre style="height: 300px;">{{ detailed_client.eligibility }}</pre>
            </b-card>
          </b-container>
        </b-modal>

      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EligibilityConfigs',
  data: () => ({
    tableFields: [
      { key: 'id', label: '#' },
      { key: 'display_name', label: 'Name' },
      { key: 'actions', label: 'Actions' },
    ],
    clients: [],
    detailed_client: {},
    loading: true,
  }),
  async beforeMount() {
    this.$store.dispatch('Core/fetchClients')
      .then(clients => {
        this.clients = clients;
      })
      .finally(() => {
        this.loading = false;
      });
  },
  methods: {
    loadEligibilityInfo(client) {
      axios.get('v3/clients/eligibility/configs', {
        params: {
          clientIds: [ client.id ],
        },
      })
        .then(eligibility => {
          this.detailed_client = { client, eligibility: eligibility.data };
          this.$bvModal.show('modal-eligibility-details');
        });
    },
  },
};
</script>

<style scoped>

</style>
